import React, { useRef } from 'react';
import { Image, Camera } from 'lucide-react';

interface CreatePostMediaOptionsProps {
  onUpload: (files: File[]) => void;
}

export const CreatePostMediaOptions: React.FC<CreatePostMediaOptionsProps> = ({ onUpload }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      onUpload(Array.from(e.target.files));
    }
  };

  return (
    <div className="w-full px-4 py-2">
      <div className="bg-[#FBF6F1] rounded-md shadow-[0px_1px_4px_0px_rgba(12,12,13,0.05)]">
        <div className="px-4 py-2 flex flex-col gap-3">
          <button className="flex items-center gap-2" onClick={handleImageClick} type="button">
            <Image className="w-4 h-4 text-[#1E3A3A]" />
            <span className="text-[#1E3A3A] text-sm font-normal font-sora leading-tight">
              Ảnh/video
            </span>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              onChange={handleFileChange}
            />
          </button>
          <button className="flex items-center gap-2" type="button">
            <Camera className="w-4 h-4 text-[#1E3A3A]" />
            <span className="text-[#1E3A3A] text-sm font-normal font-sora leading-tight">
              Camera
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}; 